function getCookie(cName) {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=')
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      let cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) {
        cEnd = document.cookie.length
      }
      return unescape(document.cookie.substring(cStart, cEnd))
    }
  }
  return ''
}

function setCookie(cName, value, expiredays) {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = cName + '=' + escape(value) + ((expiredays == null) ? '' : '; expires=' + exdate.toGMTString())
}

function nativeinfoHandle(params) {
  const nativeInfo = JSON.parse(params)
  appSdk._callJS(nativeInfo['method'], nativeInfo)
}

const appSdk = {
  _handlers: {},
  _otherInitFunc: null,
  init: function (func) {
    appSdk._otherInitFunc = func
    window.onload = function () {
      let customerid = getCookie('customerid')
      let device = getCookie('device')
      let version = getCookie('version')

      const url = document.location.href
      const start = url.indexOf('?') + 1
      if (start !== 0) {
        const queryString = url.substring(start)
        const paraNames = queryString.split('&')
        for (let i = 0; i < paraNames.length; i++) {
          const str = paraNames[i]
          const start = str.indexOf('=')
          if (start === -1) {
            continue
          }
          const name = str.substring(0, start)
          const value = str.substring(start + 1).trim()
          if (name === 'customerid') {
            customerid = value
            setCookie('customerid', customerid, 200)
          }
          if (name === 'device') {
            device = value
            setCookie('device', device, 200)
          }
          if (name === 'version') {
            version = value
            setCookie('version', version, 200)
          }
        }
      }

      if (device === 'android') {
        appSdk._androidInit()
      } else if (device === 'ios') {
        appSdk._iosInit()
      } else {
        appSdk._iosInit()
        appSdk._androidInit()
      }
      if (appSdk._otherInitFunc) {
        appSdk._otherInitFunc()
      }
      console.log('device', device)
    }
  },
  _callAndroid: null,
  _callIOS: null,
  callAPP: function (params) {
    console.log(params)
    if (appSdk._callIOS != null) {
      try {
        appSdk._callIOS(params)
      } catch (err) {

      }
    }
    if (appSdk._callAndroid != null) {
      try {
        return appSdk._callAndroid(params)
      } catch (err) {

      }
    }
    return false
  },
  register: function (method, callback) {
    if (!appSdk._handlers[method]) {
      appSdk._handlers[method] = []
    }
    appSdk._handlers[method].push(callback)
  },
  _callJS: function (method, data) {
    if (!appSdk._handlers[method]) {
      appSdk._handlers[method] = []
    }
    for (let i = 0; i < appSdk._handlers[method].length; i++) {
      appSdk._handlers[method][i](data)
    }
  },
  _androidInit: function () {
    console.log('androidInit')
    appSdk._callAndroid = function (params) {
      return window.pejsObj.PEJSCallNativeCallBack(JSON.stringify(params))
    }
  },
  _iosInit: function () {
    console.log('iosInit')
    window.onerror = function (err) {
      console.log('window.onerror: ' + err)
    }

    function setupWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        return callback()
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback)
      }
      window.WVJBCallbacks = [callback]
      const WVJBIframe = document.createElement('iframe')
      WVJBIframe.style.display = 'none'
      WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
      document.documentElement.appendChild(WVJBIframe)
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    }

    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler('PENativeCallJSCallBack', function (data, responseCallback) {
        nativeinfoHandle(data)
        responseCallback('responseData')
      })

      appSdk._callIOS = function (params) {
        bridge.callHandler('PEJSCallNativeCallBack', JSON.stringify(params), function (response) {
          console.log('app', response)
        })
      }
    })
  }
}

export default appSdk
